import React from "react";
import { useSelector } from "react-redux";
import { selectElectricalOptions, selectGeneralStation, selectPumpManifoldPiping } from "../../../redux/selectors";

const PrintElectricalOptions = () => {
  const electricalOptions = useSelector(selectElectricalOptions);
  const generalStation = useSelector(selectGeneralStation);
  const pumpManifoldPiping = useSelector(selectPumpManifoldPiping);

  const isZoneEmpty = (detail, zoneGeneralStation = {}, zonePumpManifoldPiping = {}) => {
    return (
      !detail.ControlSystem &&
      !detail.Display &&
      !detail.OptoIsolator &&
      !detail.OptoCoupler &&
      !detail.FertigationRunRelay &&
      !detail.ChemicalTreatmentRelay &&
      !detail.PhDisplay &&
      !detail.SalinityDisplay &&
      !detail.PowerPhaseMonitorProtection &&
      !detail.HourMeter &&
      !detail.RemoteStartRelay &&
      !detail.RemoteDisableRelay &&
      !detail.WattnodeMonitor &&
      !detail.IndividualMotorDisconnects &&
      !detail.DeadFront &&
      !detail.ElectricalEnclosurePaint &&
      !detail.ElectricalEnclosureMaterial &&
      !detail.PanelOrientation &&
      !detail.EnclosureCooling &&
      !detail.DisconnectType &&
      !detail.InteriorPanelLighting &&
      !detail.ExternalLighting &&
      !detail.LightedHOA &&
      !detail.RemoteMountedVFDKeypad &&
      !detail.VFDViewingWindow &&
      !detail.WindowKit &&
      !detail.SurgeProtection &&
      !detail.StationHeating &&
      !detail.DisconnectEstimatedSize &&
      !detail.DisconnectActualSize &&
      !detail.ElectricalEnclosureEstimatedSize &&
      !detail.ElectricalEnclosureActualSize &&
      !detail.Comments &&
      !detail.RemoteDisconnect &&
      !detail.SunShade &&
      !detail.AccessoryJunctionBox &&
      !zonePumpManifoldPiping.FlowMeterType &&
      !zoneGeneralStation.ElectricalEnclosureLocation &&
      !zoneGeneralStation.InterconnectWire &&
      !zoneGeneralStation.LegHeight &&
      !zoneGeneralStation.AdditionalJBox
    );
  };

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null;
    }

    return (
      <div>
        {details
          .filter(detail => detail && Object.keys(detail).length > 0)
          .map((detail, index) => {
            const zoneGeneralStation =
              generalStation.find((general) => general.Zone === detail.Zone) || {};
            const zonePumpManifoldPiping =
              pumpManifoldPiping.find((piping) => piping.Zone === detail.Zone) || {};

            if (isZoneEmpty(detail, zoneGeneralStation, zonePumpManifoldPiping)) {
              return null;
            }

            return (
              <div className="section" key={index}>
                <h3 className="print-zone-label">Zone: {detail.Zone}</h3>
                <table className="table table-bordered full-width">
                  <tbody>
                    <tr>
                      <td className="col-md-6">
                        <table>
                          <tbody>
                            <tr><td><strong>Control System: </strong>{detail.ControlSystem}</td></tr>
                            <tr><td><strong>Opto Isolator: </strong>{detail.OptoIsolator}</td></tr>
                            <tr><td><strong>Fertigation Run Relay: </strong>{detail.FertigationRunRelay}</td></tr>
                            <tr><td><strong>Ph Display: </strong>{detail.PhDisplay}</td></tr>
                            <tr><td><strong>Power Phase Monitor Protection: </strong>{detail.PowerPhaseMonitorProtection}</td></tr>
                            <tr><td><strong>Remote Start Relay: </strong>{detail.RemoteStartRelay}</td></tr>
                            <tr><td><strong>Wattnode Monitor: </strong>{detail.WattnodeMonitor}</td></tr>
                            <tr><td><strong>Dead Front: </strong>{detail.DeadFront}</td></tr>
                            <tr><td><strong>Electrical Enclosure Material: </strong>{detail.ElectricalEnclosureMaterial}</td></tr>
                            <tr><td><strong>Panel Orientation: </strong>{detail.PanelOrientation}</td></tr>
                            <tr><td><strong>Interior Panel Lighting: </strong>{detail.InteriorPanelLighting}</td></tr>
                            <tr><td><strong>Lighted HOA: </strong>{detail.LightedHOA}</td></tr>
                            <tr><td><strong>VFD Viewing Window: </strong>{detail.VFDViewingWindow}</td></tr>
                            <tr><td><strong>Surge Protection: </strong>{detail.SurgeProtection}</td></tr>
                            <tr><td><strong>Flow Meter Type: </strong>{zonePumpManifoldPiping.FlowMeterType}</td></tr>
                            <tr><td><strong>Electrical Enclosure Estimated Size: </strong>{detail.ElectricalEnclosureEstimatedSize}</td></tr>
                            <tr><td><strong>Electrical Enclosure Actual Size: </strong>{detail.ElectricalEnclosureActualSize}</td></tr>
                          </tbody>
                        </table>
                      </td>
                      <td className="col-md-6">
                        <table>
                          <tbody>
                            <tr><td><strong>Display: </strong>{detail.Display}</td></tr>
                            <tr><td><strong>Opto Coupler: </strong>{detail.OptoCoupler}</td></tr>
                            <tr><td><strong>Station Run Relay: </strong>{detail.ChemicalTreatmentRelay}</td></tr>
                            <tr><td><strong>Salinity Display: </strong>{detail.SalinityDisplay}</td></tr>
                            <tr><td><strong>Hour Meter: </strong>{detail.HourMeter}</td></tr>
                            <tr><td><strong>Remote Disable Relay: </strong>{detail.RemoteDisableRelay}</td></tr>
                            <tr><td><strong>Individual Motor Disconnects: </strong>{detail.IndividualMotorDisconnects}</td></tr>
                            <tr><td><strong>Electrical Enclosure Paint: </strong>{detail.ElectricalEnclosurePaint}</td></tr>
                            <tr><td><strong>Enclosure Cooling: </strong>{detail.EnclosureCooling}</td></tr>
                            <tr><td><strong>Disconnect Type: </strong>{detail.DisconnectType}</td></tr>
                            <tr><td><strong>External Lighting: </strong>{detail.ExternalLighting}</td></tr>
                            <tr><td><strong>Remote Mounted VFD Keypad: </strong>{detail.RemoteMountedVFDKeypad}</td></tr>
                            <tr><td><strong>Window Kit: </strong>{detail.WindowKit}</td></tr>
                            <tr><td><strong>Station Heating: </strong>{detail.StationHeating}</td></tr>
                            <tr><td><strong>Accessory Junction Box: </strong>{detail.AccessoryJunctionBox}</td></tr>
                            <tr><td><strong>Disconnect Estimated Size: </strong>{detail.DisconnectEstimatedSize}</td></tr>
                            <tr><td><strong>Disconnect Actual Size: </strong>{detail.DisconnectActualSize}</td></tr>
                            <tr><td><strong>Remote Disconnect: </strong>{detail.RemoteDisconnect}</td></tr>
                            <tr><td><strong>Sun Shade: </strong>{detail.SunShade}</td></tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    {zoneGeneralStation?.ElectricalEnclosureLocation === "OFF Skid" && (
                      <tr>
                        <td className="col-md-6">
                          <table>
                            <tbody>
                              <tr><td><strong>Electrical Enclosure Location: </strong>{zoneGeneralStation?.ElectricalEnclosureLocation}</td></tr>
                              <tr><td><strong>Interconnect Wire: </strong>{zoneGeneralStation?.InterconnectWire}</td></tr>
                              <tr><td><strong>Leg Height: </strong>{zoneGeneralStation?.LegHeight}</td></tr>
                              <tr><td><strong>Motor Leads Junction Box: </strong>{zoneGeneralStation?.AdditionalJBox}</td></tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <p><strong>Comments:</strong><br />{detail.Comments}</p>
                <br className="clearfix" />
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div>
      <h2 className="print-section-header">Electrical Options Summary</h2>
      {renderDetails(electricalOptions)}
    </div>
  );
};

export default PrintElectricalOptions;
